import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import LazyImage from '../../common/LazyImage';
import SEO from '../../common/SEO';

// Import optimized images
import M1_1 from '../../../assets/images/optimized/events/Conference-2024/M1_ (1)_optimized.jpg';
import M1_2 from '../../../assets/images/optimized/events/Conference-2024/M1_ (20)_optimized.jpg';
import M1_4 from '../../../assets/images/optimized/events/Conference-2024/M1_ (12)_optimized.jpg';
import M1_5 from '../../../assets/images/optimized/events/Conference-2024/M1_ (15)_optimized.jpg';
import M1_6 from '../../../assets/images/optimized/events/Conference-2024/M1_ (16)_optimized.jpg';
import M1_7 from '../../../assets/images/optimized/events/Conference-2024/M1_ (7)_optimized.jpg';
import M1_8 from '../../../assets/images/optimized/events/Conference-2024/M1_ (8)_optimized.jpg';
import M1_11 from '../../../assets/images/optimized/events/Conference-2024/M1_ (11)_optimized.jpg';
import M1_17 from '../../../assets/images/optimized/events/Conference-2024/M1_ (17)_optimized.jpg';
import M1_18 from '../../../assets/images/optimized/events/Conference-2024/M1_ (18)_optimized.jpg';
import M1_21 from '../../../assets/images/optimized/events/Conference-2024/M1_ (21)_optimized.jpg';
import M1_22 from '../../../assets/images/optimized/events/Conference-2024/M1_ (22)_optimized.jpg';
import M1_23 from '../../../assets/images/optimized/events/Conference-2024/M1_ (23)_optimized.jpg';
import M1_24 from '../../../assets/images/optimized/events/Conference-2024/M1_ (24)_optimized.jpg';
import M1_25 from '../../../assets/images/optimized/events/Conference-2024/M1_ (25)_optimized.jpg';
import M1_26 from '../../../assets/images/optimized/events/Conference-2024/M1_ (26)_optimized.jpg';
import M1_27 from '../../../assets/images/optimized/events/Conference-2024/M1_ (27)_optimized.jpg';
import M1_28 from '../../../assets/images/optimized/events/Conference-2024/M1_ (28)_optimized.jpg';
import M1_30 from '../../../assets/images/optimized/events/Conference-2024/M1_ (30)_optimized.jpg';
import M1_31 from '../../../assets/images/optimized/events/Conference-2024/M1_ (31)_optimized.jpg';
import M1_32 from '../../../assets/images/optimized/events/Conference-2024/M1_ (32)_optimized.jpg';
import M1_34 from '../../../assets/images/optimized/events/Conference-2024/M1_ (34)_optimized.jpg';
import M1_35 from '../../../assets/images/optimized/events/Conference-2024/M1_ (35)_optimized.jpg';
import M1_37 from '../../../assets/images/optimized/events/Conference-2024/M1_ (37)_optimized.jpg';
import M1_39 from '../../../assets/images/optimized/events/Conference-2024/M1_ (39)_optimized.jpg';
import M1_40 from '../../../assets/images/optimized/events/Conference-2024/M1_ (40)_optimized.jpg';
import M1_44 from '../../../assets/images/optimized/events/Conference-2024/M1_ (44)_optimized.jpg';
import M1_55 from '../../../assets/images/optimized/events/Conference-2024/M1_ (55)_optimized.jpg';
import M1_56 from '../../../assets/images/optimized/events/Conference-2024/M1_ (56)_optimized.jpg';
import M1_59 from '../../../assets/images/optimized/events/Conference-2024/M1_ (59)_optimized.jpg';
import M1_62 from '../../../assets/images/optimized/events/Conference-2024/M1_ (62)_optimized.jpg';
import M1_64 from '../../../assets/images/optimized/events/Conference-2024/M1_ (64)_optimized.jpg';
import ConferenceNav from '../../common/ConferenceNav';
const galleryImages = [
  {
    id: '1',
    thumbnail: M1_1,
    full: M1_1,
    title: 'Conference Moment 1',
    description: 'Keynote Session',
  },
  {
    id: '2',
    thumbnail: M1_2,
    full: M1_2,
    title: 'Conference Moment 2',
    description: 'Panel Discussion',
  },
  // { id: '3', thumbnail: M1_3, full: M1_3, title: "Conference Moment 3", description: "Workshop Session" },
  {
    id: '4',
    thumbnail: M1_4,
    full: M1_4,
    title: 'Conference Moment 4',
    description: 'Networking Event',
  },
  {
    id: '5',
    thumbnail: M1_5,
    full: M1_5,
    title: 'Conference Moment 5',
    description: 'Technical Presentation',
  },
  {
    id: '6',
    thumbnail: M1_6,
    full: M1_6,
    title: 'Conference Moment 6',
    description: 'Awards Ceremony',
  },
  {
    id: '7',
    thumbnail: M1_7,
    full: M1_7,
    title: 'Conference Moment 7',
    description: 'Group Discussion',
  },
  {
    id: '8',
    thumbnail: M1_8,
    full: M1_8,
    title: 'Conference Moment 8',
    description: 'Closing Session',
  },
  {
    id: '9',
    thumbnail: M1_11,
    full: M1_11,
    title: 'Conference Moment 9',
    description: 'Keynote Speaker',
  },
  {
    id: '10',
    thumbnail: M1_17,
    full: M1_17,
    title: 'Conference Moment 10',
    description: 'Panel Discussion',
  },
  {
    id: '11',
    thumbnail: M1_18,
    full: M1_18,
    title: 'Conference Moment 11',
    description: 'Networking Event',
  },
  {
    id: '12',
    thumbnail: M1_21,
    full: M1_21,
    title: 'Conference Moment 12',
    description: 'Technical Presentation',
  },
  {
    id: '13',
    thumbnail: M1_22,
    full: M1_22,
    title: 'Conference Moment 13',
    description: 'Awards Ceremony',
  },
  {
    id: '14',
    thumbnail: M1_23,
    full: M1_23,
    title: 'Conference Moment 14',
    description: 'Group Discussion',
  },
  {
    id: '15',
    thumbnail: M1_24,
    full: M1_24,
    title: 'Conference Moment 15',
    description: 'Closing Session',
  },
  {
    id: '16',
    thumbnail: M1_25,
    full: M1_25,
    title: 'Conference Moment 16',
    description: 'Keynote Speaker',
  },
  {
    id: '17',
    thumbnail: M1_26,
    full: M1_26,
    title: 'Conference Moment 17',
    description: 'Panel Discussion',
  },
  {
    id: '18',
    thumbnail: M1_27,
    full: M1_27,
    title: 'Conference Moment 18',
    description: 'Networking Event',
  },
  {
    id: '19',
    thumbnail: M1_28,
    full: M1_28,
    title: 'Conference Moment 19',
    description: 'Technical Presentation',
  },
  {
    id: '20',
    thumbnail: M1_30,
    full: M1_30,
    title: 'Conference Moment 20',
    description: 'Awards Ceremony',
  },
  {
    id: '21',
    thumbnail: M1_31,
    full: M1_31,
    title: 'Conference Moment 21',
    description: 'Group Discussion',
  },
  {
    id: '22',
    thumbnail: M1_32,
    full: M1_32,
    title: 'Conference Moment 22',
    description: 'Closing Session',
  },
  {
    id: '23',
    thumbnail: M1_34,
    full: M1_34,
    title: 'Conference Moment 23',
    description: 'Keynote Speaker',
  },
  {
    id: '24',
    thumbnail: M1_35,
    full: M1_35,
    title: 'Conference Moment 24',
    description: 'Panel Discussion',
  },
  {
    id: '25',
    thumbnail: M1_37,
    full: M1_37,
    title: 'Conference Moment 25',
    description: 'Networking Event',
  },
  {
    id: '26',
    thumbnail: M1_39,
    full: M1_39,
    title: 'Conference Moment 26',
    description: 'Technical Presentation',
  },
  {
    id: '27',
    thumbnail: M1_40,
    full: M1_40,
    title: 'Conference Moment 27',
    description: 'Awards Ceremony',
  },
  {
    id: '28',
    thumbnail: M1_44,
    full: M1_44,
    title: 'Conference Moment 28',
    description: 'Group Discussion',
  },
  {
    id: '29',
    thumbnail: M1_55,
    full: M1_55,
    title: 'Conference Moment 29',
    description: 'Closing Session',
  },
  {
    id: '30',
    thumbnail: M1_56,
    full: M1_56,
    title: 'Conference Moment 30',
    description: 'Keynote Speaker',
  },
  {
    id: '31',
    thumbnail: M1_59,
    full: M1_59,
    title: 'Conference Moment 31',
    description: 'Panel Discussion',
  },
  {
    id: '32',
    thumbnail: M1_62,
    full: M1_62,
    title: 'Conference Moment 32',
    description: 'Networking Event',
  },
  {
    id: '33',
    thumbnail: M1_64,
    full: M1_64,
    title: 'Conference Moment 33',
    description: 'Technical Presentation',
  },
];

const ConferenceGallery = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);


  const handleImageClick = image => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };


  const handleNextImage = React.useCallback(() => {
    if (!selectedImage) return;
    const currentIndex = galleryImages.findIndex(
      img => img.id === selectedImage.id
    );
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[nextIndex]);
  }, [selectedImage]);

  const handlePrevImage = React.useCallback(() => {
    if (!selectedImage) return;
    const currentIndex = galleryImages.findIndex(
      img => img.id === selectedImage.id
    );
    const prevIndex =
      (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setSelectedImage(galleryImages[prevIndex]);
  }, [selectedImage]);

  const handleCloseModal = React.useCallback(() => {
    setIsModalOpen(false);
    setSelectedImage(null);
  }, []);

  // Handle keyboard navigation
  React.useEffect(() => {
    const handleKeyPress = e => {
      if (!isModalOpen) {
        return;
      }

      switch (e.key) {
        case 'Escape':
          handleCloseModal();
          break;
        case 'ArrowLeft':
          handlePrevImage();
          break;
        case 'ArrowRight':
          handleNextImage();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isModalOpen, handleCloseModal, handleNextImage, handlePrevImage]);


  return (
    <>
      <SEO 
        title="Scientific Research Conference Gallery | AEG Group Bhopal"
        description="Explore photos and highlights from Scientific Research conferences, Conference paper writing publication events, and thesis writing seminars in Bhopal."
        canonicalPath="/conference-gallery"
        keywords={[
          "Scientific Research",
          "Conference paper writing publication",
          "Paper Writing Bhopal",
          "best thesis writing services in bhopal"
        ]}
      />
      <ConferenceNav />
      <div className='min-h-screen bg-gradient-to-br pt-8'>
        <div className='max-w-full px-4 sm:px-6 lg:px-8 mt-20'>
          {/* Header */}
          <div className='text-center  mb-10 '>
            <h1 className='text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4'>
              Conference Gallery
            </h1>
            <p className='text-xl text-gray-600 font-medium'>
              Capturing moments from AIC-RAETHM 2024
            </p>
            <div className='w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto mt-4 rounded-full'></div>
          </div>

          {/* Gallery Grid - Fixed layout with proper spacing */}
          <div className='grid grid-cols-1 sm:grid-cols-2 w-full h-full lg:grid-cols-3 xl:grid-cols-3  gap-6 mb-12'>
            {galleryImages.map(image => (
              <div
                key={image.id}
                onClick={() => handleImageClick(image)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleImageClick(image);
                  }
                }}
                role='button'
                tabIndex={0}
                aria-label={`View ${image.title} in full size`}
                className='group cursor-pointer relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white max-w-sm mx-auto w-26'
              >
                {/* Image Container with fixed dimensions */}
                <div className='relative w- h-52 flex flex-col items-center justify-center'>
                  <LazyImage
                    src={image.thumbnail}
                    alt={`${image.title} - ${image.description} - AEG Research Conference Gallery Bhopal`}
                    className='max-h-[85vh] h-80 w-auto object-contain rounded-xl shadow-2xl'
                    style={{
                      maxWidth: 'min(95vw, 1200px)',
                      margin: 'auto',
                    }}
                  />
                </div>
                {/* <div className="flex-1 flex items-center justify-center">
                <img
                  src={selectedImage.full}
                  alt={selectedImage.title}
                  className="max-h-[85vh] w-auto object-contain rounded-xl shadow-2xl"
                  style={{
                    maxWidth: 'min(95vw, 1200px)',
                    margin: 'auto',
                  }}
                /> */}

                {/* Overlay */}
                <div className='absolute top-0 left-0 right-0 bottom-16 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-t-2xl'>
                  <div className='absolute inset-0 flex items-center justify-center'>
                    <div className='bg-white/20 backdrop-blur-sm rounded-full  transform scale-0 group-hover:scale-100 transition-transform duration-300'>
                      <svg
                        className='w-8 h-8 text-white'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
                        />
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Content Card */}
                {/* <div className="p-4 bg-white rounded-b-2xl">
                <h3 className="font-bold text-lg text-gray-800 mb-1 group-hover:text-blue-600 transition-colors line-clamp-1">
                  {image.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-2">
                  {image.description}
                </p>
              </div> */}

                {/* Hover Border Effect */}
                <div className='absolute inset-0 border-2 border-transparent group-hover:border-blue-400 rounded-2xl transition-colors duration-300'></div>
              </div>
            ))}
          </div>
        </div>

        {/* Enhanced Modal/Lightbox - Full screen optimization */}
        {isModalOpen && selectedImage && (
          <div className='fixed inset-0 bg-black/96 z-50 flex items-center justify-center '>
            <div className='relative w-full h-full flex flex-col  '>
              {/* Header Controls - Simplified */}
              <div className='absolute top-0 left-0  right-0 flex justify-between items-center p-6 z-30 bg-gradient-to-b from-black/70 to-transparent'>
                <div className='text-black max-w-md'>
                  {/* <h3 className="text-2xl font-bold truncate">{selectedImage.title}</h3>
                  <p className="text-gray-300 mt-1 text-sm">{selectedImage.description}</p> */}
                </div>

                <div className='flex items-center gap-3'>
                  <button
                    onClick={handleCloseModal}
                    className='p-3 rounded-full bg-black/50 backdrop-blur-sm text-black hover:bg-black/70 transition-all duration-200 hover:scale-110'
                    title='Close (Esc)'
                  >
                    <X size={24} />
                  </button>
                </div>
              </div>

              {/* Main Image Display - Full size centered */}
              <div className='flex-1 flex items-center  w-screen h-52 justify-center'>
                <LazyImage
                  src={selectedImage.full}
                  alt={`${selectedImage.title} - ${selectedImage.description} - AEG Research Conference Gallery Bhopal`}
                  className='max-h-[85vh] w-auto object-contain rounded-xl shadow-2xl'
                  style={{
                    maxWidth: 'min(95vw, 1200px)',
                    margin: 'auto',
                  }}
                />

                {/* Navigation Buttons - Repositioned */}
                <button
                  onClick={handlePrevImage}
                  className='fixed left-6 top-1/2 transform -translate-y-1/2 p-4 rounded-full bg-black/50 backdrop-blur-sm text-white hover:bg-black/70 transition-all duration-200 hover:scale-110 z-20'
                  title='Previous image (←)'
                >
                  <ChevronLeft size={32} />
                </button>
                <button
                  onClick={handleNextImage}
                  className='fixed right-6 top-1/2 transform -translate-y-1/2 p-4 rounded-full bg-black/50 backdrop-blur-sm text-white hover:bg-black/70 transition-all duration-200 hover:scale-110 z-20'
                  title='Next image (→)'
                >
                  <ChevronRight size={32} />
                </button>
              </div>

              {/* Simplified Bottom Navigation - Smaller and cleaner */}
              <div className='fixed bottom-8 left-1/2 transform -translate-x-1/2 z-20'>
                <div className='flex space-x-1 bg-black/60 backdrop-blur-md rounded-full px-3 py-2'>
                  {galleryImages.slice(0, 10).map((image, index) => (
                    <button
                      key={image.id}
                      onClick={() => setSelectedImage(image)}
                      className={`w-72 h-1.5 rounded-full transition-all duration-200 ${
                        image.id === selectedImage.id
                          ? 'bg-white scale-150'
                          : 'bg-white/40 hover:bg-white hover:scale-110'
                      }`}
                    />
                  ))}
                  {galleryImages.length > 10 && (
                    <div className='text-white/60 text-xs px-2'>...</div>
                  )}
                </div>
              </div>

              {/* Image Counter - Repositioned */}
              <div className='fixed bottom-8 right-8 bg-black/60 backdrop-blur-md rounded-full px-4 py-2 text-white text-sm font-medium z-20'>
                {galleryImages.findIndex(img => img.id === selectedImage.id) +
                  1}{' '}
                / {galleryImages.length}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConferenceGallery;
